export default __webpack_public_path__ + "static/media/design2.3a53b961.png";